// Map.prototype.getOrInsertComputed — nativo no Chrome 131+, ausente no Safari/WebKit (iPad/iPhone).
// esbuild 0.25+ gera chamadas a esse método quando otimiza padrões Map.get+set.
if (typeof (Map.prototype as any).getOrInsertComputed === 'undefined') {
    (Map.prototype as any).getOrInsertComputed = function <K, V>(key: K, callbackfn: (key: K) => V): V {
        if (!this.has(key)) this.set(key, callbackfn(key));
        return this.get(key);
    };
}

// WeakMap.prototype.getOrInsertComputed — mesma situação
if (typeof (WeakMap.prototype as any).getOrInsertComputed === 'undefined') {
    (WeakMap.prototype as any).getOrInsertComputed = function <K extends object, V>(key: K, callbackfn: (key: K) => V): V {
        if (!this.has(key)) this.set(key, callbackfn(key));
        return this.get(key);
    };
}
